(function () {
    $ (function () {
        $ ('.js-carousel-posts').each (function () {
            const $carousel = $ (this);
            const $wrap = $carousel.parents ('[data-role="wrap"]');
            const $prev = $wrap.find ('[data-role="prev"]');
            const $next = $wrap.find ('[data-role="next"]');

            // Init
            let settings = {
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true,
                touchThreshold: 10,
                infinite: false,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: globObj.breakpoints.sm,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: globObj.breakpoints.md,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    },
                    {
                        breakpoint: globObj.breakpoints.lg,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            arrows: true,
                            dots: false
                        }
                    }
                ]
            };

            if ($prev.length > 0) {
                settings.prevArrow = $prev;
            }

            if ($next.length > 0) {
                settings.nextArrow = $next;
            }

            function checkMobile () {
                if (window.innerWidth <= globObj.breakpoints.lg) {
                    if ($carousel.hasClass ('slick-initialized')) {
                        $carousel.slick ('unslick');

                        let $items = $carousel.find ("[data-role=\"item\"]");

                        if ($items.length > 4) {
                            let i = 0;
                            $items.each (function () {
                                if (i >= 4) {
                                    $ (this).addClass ("_hiddenMob");
                                }
                                i++;
                            });

                            $carousel.append (`<div class="b-posty-more js-carousel-posts-showMore"><div class="b-posty-more__inner"><button class="b-btn _transp">Показать еще</button></div></div>`);
                        }
                    }
                    return
                }
                if (!$carousel.hasClass ('slick-initialized')) {
                    return $carousel.slick (settings);
                }
            }

            $carousel.slick (settings);
            $ (window).on ('resize', function () {
                checkMobile ();
            }).trigger ("resize");

            $carousel.on ("click", ".js-carousel-posts-showMore", function (e) {
                e.preventDefault ();
                $carousel.find ("[data-role=\"item\"]").removeClass ("_hiddenMob");
                $ (this).remove ();
            });
        });
    })
} ());
